import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { OrderHistoryConfirmedApi } from "@/features/my-order/features/order-history/features/final-copy/api";
import { OrderHistoryConfirmedUpdateStatusRequest } from "@/features/my-order/features/order-history/features/final-copy/types";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";

const usePutOrderSheetSetUpdateStatus = (orderSheetSetId: number) => {
  const queryClient = useQueryClient();
  const identity = useIdentity();
  const [searchParams, setSearchParams] = useSearchParams();

  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  const companyId = identity?.company?.id;

  const { mutate: updateStatus, isPending } = useMutation({
    mutationKey: ["updateOrderSheetSetStatus", orderSheetSetId],
    mutationFn: (params: OrderHistoryConfirmedUpdateStatusRequest) =>
      OrderHistoryConfirmedApi.updateStatus(companyType!, companyId!, params),
    onSuccess: (data) => {
      const nextStatus = data.order_sheet_sets?.[0]?.status;

      if (nextStatus) {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set("status", nextStatus);
        setSearchParams(nextParams, { replace: true });
      }

      queryClient.invalidateQueries({
        queryKey: ["order-history", "confirmed-list"],
      });
    },
  });

  return {
    updateStatus,
    isPending,
  };
};

export default usePutOrderSheetSetUpdateStatus;
